module.exports = __webpack_public_path__ + "6df36126b99b2c6aad99219bcf6bd889.svg";